import { createFileRoute } from '@tanstack/react-router';

import { AuthCallback } from '@/lib/auth/AuthCallback';

export const Route = createFileRoute('/oidc/callback')({
  component: AuthCallback,
});
